import { NormalizedNavItem } from '../types/navdata'

export default function flattenItems(
  items: NormalizedNavItem[]
): NormalizedNavItem[] {
  let res: NormalizedNavItem[] = []
  for (let item of items) {
    res = res.concat(flattenItems(item.items))
    res.push(item)
  }
  return res
}
